import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from '../text/Text'
import FaIcon from '../faIcon/FaIcon'

const ProgressTitle = ({ name, icon, iconSize = 'sm', titleProps, sx }) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='center'
      sx={{ mb: 0.5, ...sx }}
    >
      {icon && <FaIcon icon={icon} size={iconSize} />}
      <Text variant='subtitle2' color='inherit' label={name} {...titleProps} />
    </Stack>
  )
}

export default memo(ProgressTitle)
